import { track as tracker } from '@amplitude/analytics-browser'

import { BaseEvent, EventOptions, TrackingProperties } from './trackerTypes'
import { TypedTrack } from './typedEvents'

const printEvent = (
  eventInput: BaseEvent,
  eventProperties?: TrackingProperties,
  eventOptions?: EventOptions
) => {
  /* eslint no-console: ["error", { allow: ["table", "group", "groupCollapsed", "groupEnd"] }] */

  console.group(`Track event: ${eventInput}`)

  if (eventProperties) {
    console.groupCollapsed('Properties')
    console.table(eventProperties)
    console.groupEnd()
  }

  if (eventOptions) {
    console.groupCollapsed('Options')
    console.table(eventOptions)
    console.groupEnd()
  }

  console.groupEnd()
}

export const track: TypedTrack = async (
  eventInput: BaseEvent,
  eventProperties?: TrackingProperties,
  eventOptions?: EventOptions
) => {
  if (window.logEvents === true) {
    printEvent(eventInput, eventProperties, eventOptions)
    return true
  }

  if (Boolean(window.ReactNativeWebView)) return true
  if (!window.tracking) return true

  await tracker(eventInput, eventProperties, eventOptions).promise

  return true
}
